import { z } from 'zod'

export const EmailChangeRequest = z.object({
  email: z.string().email()
})

export const EmailChangeRequested = z.object({
  current_factor: z.enum(['totp', 'email'])
})

export const EmailChangeVerify = z.object({
  otp: z.string().min(6),
  current_otp: z.string()
})

export type EmailChangeRequest = z.infer<typeof EmailChangeRequest>
export type EmailChangeRequested = z.infer<typeof EmailChangeRequested>
export type EmailChangeVerify = z.infer<typeof EmailChangeVerify>
